<router-outlet></router-outlet>
<app-loader></app-loader>

<ng-template #sessionDialog>
    <h2 mat-dialog-title>Session Expired</h2>
    <div mat-dialog-content>
        You have been logged out due to inactivity.
    </div>
    <div mat-dialog-actions class="action-btn">
        <button mat-button class="next-btn" mat-dialog-close>Ok</button>
    </div>
</ng-template>